import {Subject, BehaviorSubject} from 'rxjs';
import {delay, map, retryWhen, throttleTime, filter} from 'rxjs/operators';
import {WS_STATUS} from '@/emum';
import {wwData$} from '@/streams/worker-data';
import {WebsocketSubject} from '@/observable/WebsocketSubject';
import {ty} from '@/da/tingyun';

export const wsStatus$ = new BehaviorSubject(WS_STATUS.INIT);
export const delay$ = new Subject();
const wsOpening$ = new Subject();
export const wsOpen$ = new Subject();
const wsClosing$ = new Subject();
const wsClose$ = new Subject();

const options = {
  openingObserver: wsOpening$,
  openObserver: wsOpen$,
  closingObserver: wsClosing$,
  closeObserver: wsClose$,
  delayObserver: delay$,
};

// 目前 用来发送订阅
export const ws$ = new WebsocketSubject(options);

// 重连后自动订阅
// 目前用来 接受订阅
export const wsMsg$ = ws$.pipe(retryWhen((errors) => errors.pipe(delay(1000))));

delay$.pipe(throttleTime(30000)).subscribe((delay) => {
  ty.createEvent({key: 'ws_heartbeat_success', duration: delay});
});

wwData$
  .pipe(
    filter((o) => o.type === 'ws-status'),
    map((o) => o.data.status)
  )
  .subscribe((status) => {
    if (status === 'Opening') {
      wsOpening$.next(status);
    }
    if (status === 'Opened') {
      wwData$.next({type: 'ty-ready'});
      wsOpen$.next(status);
    }
    wsStatus$.next(status);
  });
